module.exports = __webpack_public_path__ + "static/media/postman.4d2624cf.png";